import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import SimulationRepository from '../Repositories/SimulationRepository'


class DetailBloc {

    simulationChannel = new Subject();
    cancelChannel = new Subject();
    repository = new SimulationRepository()

    constructor() {
        this.simulationChannel.next({status: apiResponse.INITIAL})
        this.cancelChannel.next({status: apiResponse.INITIAL})
    }

    fetchSimulation = async (query) => {
        this.simulationChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchSimulation(query).then((result) => {
                this.simulationChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.simulationChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {}
    }

    fetchCancel = async (query) => {
        this.cancelChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchCancel(query).then((result) => {
                this.cancelChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.cancelChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            this.cancelChannel.next({status: apiResponse.ERROR, data: error})
        }
    }

}

export default DetailBloc